import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        // Base — 44px touch target on mobile, 40px on desktop
        "flex h-11 sm:h-10 w-full rounded-md border border-input bg-card px-3 py-2 text-base shadow-xs transition-all",
        // File input
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        // Placeholder + hover/focus — branded orange ring
        "placeholder:text-muted-foreground/70",
        "hover:border-foreground/20",
        "focus-visible:outline-none focus-visible:border-brand-orange focus-visible:ring-4 focus-visible:ring-brand-orange/15",
        // Disabled
        "disabled:cursor-not-allowed disabled:opacity-60 disabled:bg-brand-beige-60",
        // Desktop text size
        "md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
